import React, {useEffect} from 'react';
import { useDispatch, useSelector } from "react-redux";
import TooltipIcon from "./TooltipIcon";

import CloseIcon from '@mui/icons-material/Close';

import {
    appSetModalContent
} from "../../redux/app/appActions";
import {dataRemoveFilter} from "../../redux/data/dataActions";
import {PAGE_COMPONENT_CONFIGURATION, PAGE_COMPONENT_EDIT} from "../../redux/page/pageTypes";

import {
    styled,
    useTheme,
    Dialog,
    DialogTitle as MuiDialogTitle,
    DialogContent as MuiDialogContent,
    Fab,
} from '@mui/material';

const PREFIX = 'Modal';

const classes = {
    root: `${PREFIX}-root`,
    closeButton: `${PREFIX}-closeButton`,
    paper: `${PREFIX}-paper`,
    closeButtonSolo: `${PREFIX}-closeButtonSolo`
};

const StyledDialog = styled(Dialog)((
	{
		theme
	}
) => {
	return {
		[`& .${classes.closeButton}`]: {
			position: 'absolute',
			right: theme.spacing(1),
			top: theme.spacing(1),
			color: theme.palette.grey[500]
		},
		[`& .${classes.closeButtonSolo}`]: {
			position: 'absolute',
			left: "8px",
			bottom: "8px",
			color: theme.palette.grey[500],
			zIndex: 99
		}
	}
});

const StyledDialogTitle = styled(MuiDialogTitle)((
	{
		theme
	}
) => ({
	margin: 0,
	paddingTop: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingBottom: theme.spacing(3),
    paddingLeft: theme.spacing(1),
}));

const StyledDialogContent = styled(MuiDialogContent)((
	{
		theme
	}
) => ({
	padding: '0px',
	margin: '0px',
	border: 'none'
}));

const DialogTitle = ((props) => {
    const { children,  onClose, ...other } = props;
    const theme = useTheme();

    return (
        <StyledDialogTitle {...other} variant="h6">
			{children}
            {onClose ? (
                // <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                //     <CloseIcon />
                // </IconButton>
                <Fab size="small" color="primary" aria-label="close" style={{...children.button}} className={classes.closeButton} onClick={onClose}>
                    <CloseIcon style={{color: theme.palette.primary.contrastText}}/>
                </Fab>
                // <Fab size="small" color="primary" aria-label="close" className={classes.closeButton} onClick={onClose}>
                //     <CloseIcon style={{color: theme.palette.primary.contrastText}}/>
                // </Fab>
            ) : null}
        </StyledDialogTitle>
    );
});

export default function Modal() {
    const dispatch = useDispatch();
    const theme = useTheme();

    // App State
    const modalContent = useSelector(state => state.app.modalContent);
    const filters = useSelector(state => state.data.filters);
	const editXId = useSelector(state => state.page.componentEdit.xId);
	const pages = useSelector(state => state.page.pages);
	const isThemeLight = useSelector(state => state.persist.themeLight);

	// console.log('******MODAL CONTENT******', modalContent);
    // console.log('******MODAL TOOLTIP CONTENT******', modalContent.tooltipContent);

    // Component State
    const [open, setOpen] = React.useState(true);
    const [focused , setFocused] = React.useState(false);
    const [tooltipEnabled, setTooltipEnabled] = React.useState(null);

    useEffect(() => {
        if (modalContent.tooltipContent && modalContent.tooltipContent.enabled === true) {
            setTooltipEnabled(true);
        } else {
            setTooltipEnabled(false);
        }
    }, [modalContent.tooltipContent]);

    const handleClose = () => {
        setOpen(false);
        dispatch(appSetModalContent(null));

        // -412 represents a filter applied for a click that produces a Modal (FormatUtilities.js --> FormatModalLink)
        const filterModalExists = filters.find(f => {
            return f.id.toLowerCase() === "-412"
        });
        if (filterModalExists) {
            // Remove the filter for modal because the user's intent is to get more data, not filter the app
            dispatch(dataRemoveFilter("-412"));
        }

		// Modal closed, clear out editXId value because new values triggers Modal to open
		if (editXId) {
			dispatch({
				type: PAGE_COMPONENT_EDIT,
				payload: {
					xId: null,
					xIdHint: null
				}
			});

			dispatch({
				type: PAGE_COMPONENT_CONFIGURATION,
				payload: {
					id: null,
					action: null,
					type: null,
					config: null,
					pages: pages
				}
			});
		}
    };

    const handleMouseEnter = (e) => {
        setFocused(true);
    };

    const handleMouseLeave = (e) => {
        setFocused(false);
    };

    return (
        <StyledDialog PaperProps={{ sx: {...modalContent.parent, margin: '0px'} }} modalcontent={modalContent} onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
            {modalContent.title &&
                <DialogTitle sx={{backgroundColor: theme.palette.background.paper, backgroundImage: isThemeLight ? '' : 'linear-gradient(rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05))'}} id="customized-dialog-title" onClose={ ()=> { handleClose() } }>
                    {modalContent.title}
                </DialogTitle>
            }
            <StyledDialogContent
                dividers
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}>
                {!modalContent.title && focused &&
                    // <IconButton aria-label="close" className={classes.closeButtonSolo} onClick={handleClose}>
                    //     <CloseIcon/>
                    // </IconButton>
                    <Fab size="small" color="primary" aria-label="close" className={classes.closeButtonSolo} onClick={() =>{ handleClose() }}>
                        <CloseIcon style={{color: theme.palette.primary.contrastText}}/>
                    </Fab>
                }
                {tooltipEnabled &&
                    <TooltipIcon tooltip={modalContent.tooltipContent} />
                }
                { modalContent.content }
            </StyledDialogContent>
        </StyledDialog>
    );
}
